import { QUIZ_RESULTS_DATA_ENDPOINT } from '@/constants/endpoints'

export default {
  methods: {
    async getQuizResultsData (email, score) {
      const params = new URLSearchParams()
      params.append('email', email)
      params.append('score', score)
      try {
        return await this.$axios.$get(QUIZ_RESULTS_DATA_ENDPOINT, { params })
      } catch (e) {
      }
      return null
    }
  }
}
